import { Switch } from "@headlessui/react";
import Icon from "../icons/icon";
import GridFill from "../icons/lib/grid-fill";
import List from "../icons/lib/list";

interface ToggleButtonProps {
  id?: string;
  value: boolean;
  onChange: Function;
  mobile?: boolean;
  className?: string;
}

const ToggleButton = ({
  id,
  value,
  onChange,
  mobile = false,
  className,
}: ToggleButtonProps) => {
  if (mobile) {
    return (
      <Switch
        id={`mobile-${id}`}
        checked={value}
        onChange={() => onChange()}
        className={`w-[80px] h-medium shrink-0 cursor-pointer rounded-full border-[1px] border-black focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 ${
          className ?? className
        }`}
      >
        <Icon
          icon={GridFill}
          className="absolute h-full ml-[9.5px] my-auto z-10"
          color={value ? "black" : "white"}
        />
        <Icon
          icon={List}
          className="absolute h-full right-0 mr-[10px] my-auto z-10"
          color={!value ? "black" : "white"}
        />
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${
            value ? "translate-x-[20px]" : "translate-x-[-20px]"
          } mt-1
                pointer-events-none inline-block h-[30px] w-[30px] transform rounded-full bg-black shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    );
  } else {
    return (
      <Switch
        id={id}
        checked={value}
        onChange={() => onChange()}
        className={`switch-btn relative items-center h-big  w-[100px] shrink-0 cursor-pointer rounded-full border-[1px] border-black focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 ${
          className ?? className
        }`}
      >
        <Icon
          icon={GridFill}
          className="absolute h-full ml-[13.5px] my-auto z-10"
          color={value ? "black" : "white"}
          size={20}
        />
        <Icon
          icon={List}
          className="absolute h-full right-0 mr-[16px] my-auto z-10"
          color={!value ? "black" : "white"}
          size={20}
        />
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${value ? "translate-x-[55px] " : "translate-x-2"}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-black shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    );
  }
};
export default ToggleButton;
